export class CacheItem {
    public key: string;
    public data: any;
    public timestamp: number;

    constructor(key: string, data: any, timestamp?: number) {
        this.key = key;
        this.data = data;
        this.timestamp = !timestamp ? Date.now() : timestamp;
    }

    toString(): string {
        return JSON.stringify({
            key: this.key,
            data: this.data,
            timestamp: this.timestamp
        });
    }
}
